import { API, API_PROV, NODE_ENV } from '@/config';
import axios from 'axios';
import { requestInterceptor, responseInterceptor } from './interceptor';

export const http = axios.create({
  baseURL: API.BASE_URL,
  timeout: NODE_ENV === 'production' ? API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(
  requestInterceptor.onFulfilled,
  requestInterceptor.onRejected
);

http.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
);

export const providerApi = axios.create({
  baseURL: API_PROV.BASE_URL,
  timeout: NODE_ENV === 'production' ? API_PROV.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

providerApi.interceptors.request.use(
  requestInterceptor.onFulfilled,
  requestInterceptor.onRejected
);

providerApi.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
);
